import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import './photo-holder.css'

const PhotoHolder = (props) => {
  const { photoUrl, video } = props;

  useEffect(() => {
    const stream = async () => {
      if (!photoUrl && video){
        const streaming = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
        if(streaming) video.current.srcObject = streaming;
      } 
    }
    stream();
  }, [video, photoUrl]);

  return (
    <div className={`photo-holder-container ${props.rootClassName} `}>
      <div className="photo-holder-container1" >
        {video && (<video ref={video} id="video" autoPlay />)}
        {props.children}
      </div>
    </div>
  )
}

PhotoHolder.defaultProps = {
  rootClassName: '',
}

PhotoHolder.propTypes = {
  rootClassName: PropTypes.string,
}

export default PhotoHolder
